import React from "react";
import { Control, Select } from "@allxsmith/bestax-bulma";

export default function QuoteTypeSelector({onChange, selectedtype}){


    return (
        <div>
            <label className="label">Quote Type</label>
            <Control>
                <Select
                    name={"purpose"}
                    value={selectedtype ? selectedtype : 0}
                    onChange={onChange}
                >
                    <option key={"NONE"} value={"NONE"}>NONE</option>
                    <option key={"OFF HIRE"} value={"OFF HIRE"}>OFF HIRE</option>
                    <option key={"INSURANCE CLAIM"} value={"INSURANCE CLAIM"}>INSURANCE CLAIM</option>
                    <option key={"CUSTOMER VEHICLE"} value={"CUSTOMER VEHICLE"}>CUSTOMER VEHICLE</option>
                    <option key={"OUT ON HIRE"} value={"OUT ON HIRE"}>OUT ON HIRE</option>
                    <option key={"SALES"} value={"SALES"}>SALES</option>
                    <option key={"WORK COMPLETE"} value={"WORK COMPLETE"}>WORK COMPLETE</option>
                    <option key={"EXTERNAL"} value={"EXTERNAL"}>EXTERNAL</option>
                    <option key={"TOTAL LOSS"} value={"TOTAL LOSS"}>TOTAL LOSS</option>
                </Select>
            </Control>
        </div>
    );





}